// extracted by mini-css-extract-plugin
module.exports = {"animationsContainer":"SliderFlex_animationsContainer__N9bdD","container":"SliderFlex_container__bDbWI","words":"SliderFlex_words__Y_YAp"};